import React, { useCallback } from "react"

import classNames from "classnames"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import { AltImage } from "../AltImage"
import { ConditionalWrapper } from "../ConditionalWrapper"
import { LazyImage } from "../LazyImage"
import * as styles from "./RCAImage.module.scss"

const RCAImage = ({
  image,
  cloudinaryImage,
  altOverlay = true,
  alt,
  title,
  fluidOverrides = {},
  imageClassName,
  containerClassName,
  noBorder = false,
  sx = {},
  className,
  ...props
}) => {
  // const borderWidth = useResponsiveValue(theme.sizes.borderWidth)

  const sanitizedAlt = alt && alt.startsWith("http://") ? alt.substring(7) : alt

  const onLoad = useCallback(() => {
    window.dispatchEvent(
      new Event("tile-loaded", {
        bubbles: true,
      }),
    )
  }, [])

  return (
    <div
      className={classNames(
        styles.outer,
        { [styles.noBorder]: noBorder, [styles.hasImage]: !!image },
        className,
      )}
      {...props}
    >
      {" "}
      <ConditionalWrapper
        condition={!cloudinaryImage && altOverlay}
        wrapper={(children) => (
          <AltImage alt={sanitizedAlt}>{children}</AltImage>
        )}
      >
        <div className={styles.curtain} />
        <div className={classNames(styles.container, containerClassName)}>
          {image && typeof image === "string" && (
            <LazyImage
              src={image}
              alt={sanitizedAlt}
              title={title}
              className={classNames(imageClassName)}
            />
          )}
          {image && typeof image !== "string" && (
            <GatsbyImage
              image={image}
              className={classNames(imageClassName)}
              alt={sanitizedAlt}
              title={title}
              onLoad={onLoad}
              loading="lazy"
            />
          )}
          {cloudinaryImage && (
            // <Image
            //   fluid={{ ...cloudinaryImage, ...fluidOverrides }}
            //   className={classNames(imageClassName)}
            //   alt={sanitizedAlt}
            //   title={title}
            //   onLoad={onLoad}
            //   loading="lazy"
            // />
            <GatsbyImage
              // TO FIX!
              // previously we passed fluidOverrides to the image
              // perhaps we should pass it to the GatsbyImage somehow?
              // image={{ cloudinaryImage, ...fluidOverrides }}
              image={cloudinaryImage}
              className={classNames(imageClassName)}
              alt={sanitizedAlt}
              title={title}
              onLoad={onLoad}
              loading="lazy"
            />
          )}
        </div>
      </ConditionalWrapper>
    </div>
  )
}

RCAImage.propTypes = {
  // The gatsby sharp fluid object
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  // An alt attr for the image
  alt: PropTypes.string,

  // A title attr for the image
  title: PropTypes.string,

  // Any overrides to apply to the image object
  fluidOverrides: PropTypes.object,

  // The theme ui styling object
  sx: PropTypes.object,
}

export { RCAImage }
